<div [formGroup]="form">
    <div class="page-header">
        <h1 *ngIf="formType === ApplicationType.Victim_Application">Medical & Dental Information</h1>
        <h1 *ngIf="formType === ApplicationType.IFM_Application || formType === ApplicationType.Witness_Application">Medical Information</h1>
    </div>
    <p>This section provides information regarding any medical or dental treatment you received as a result of the crime.</p>

    <section>
        <h2 class="blue-header">Coverage</h2>

        <h3>
            Medical Services Coverage <app-tool-tip [trigger]="mspTemplate"></app-tool-tip>
        </h3>
        <ng-template #mspTemplate>Medical Services Plan (MSP) enrolment is mandatory for all residents of BC</ng-template>

        <app-field label="Do you have provincial medical services coverage? (e.g. BC Care Card or other provincial coverage)" [valid]="isFieldValid('doYouHaveMedicalServicesCoverage')" [required]="true" errorMessage="Please select whether you have provincial medical services coverage">
            <label class="inline-label">
                <input type="radio" [value]="true" name="doYouHaveMedicalServicesCoverage" formControlName="doYouHaveMedicalServicesCoverage" (change)="doYouHaveMedicalServicesCoverageChange(true)">
                <span>Yes</span>
            </label>
            <label class="inline-label">
                <input type="radio" [value]="false" name="doYouHaveMedicalServicesCoverage" formControlName="doYouHaveMedicalServicesCoverage" (change)="doYouHaveMedicalServicesCoverageChange(false)">
                <span>No</span>
            </label>
        </app-field>
        <section *ngIf="form.get('doYouHaveMedicalServicesCoverage').value === true">
            <app-field label="Province" [required]="true" errorMessage="Please select a province" [valid]="isMyControlValid(form.get('haveMedicalCoverageProvince'))">
                <select class="form-control standard" formControlName="haveMedicalCoverageProvince" #haveMedicalCoverageProv>
                    <option *ngFor="let item of provinceList" [ngValue]="item">{{ item }}</option>
                </select>
                <app-field label="" [valid]="isMyControlValid(form.get('haveMedicalCoverageProvinceOther'))" errorMessage="Please enter province"></app-field>
                <input *ngIf="form.get('haveMedicalCoverageProvince').value==='Other'" class="form-control standard" type="text" formControlName="haveMedicalCoverageProvinceOther" value="haveMedicalCoverageProv.value">
            </app-field>
            <app-field label="Personal Health Number">
                <input class="form-control standard" type="text" formControlName="personalHealthNumber">
            </app-field>
        </section>

        <h3>
            Other Health Coverage <app-tool-tip [trigger]="otherHealthTemplate"></app-tool-tip>
        </h3>
        <ng-template #otherHealthTemplate><strong>Health Plan / Dental Plan Coverage</strong><br />CVAP will only pay expenses or provide benefits that are not already covered by your existing health or dental plan</ng-template>
        <app-field label="Do you have other health coverage? (e.g. Blue Cross)" [valid]="isFieldValid('doYouHaveOtherHealthCoverage')" [required]="true" errorMessage="Please select whether you have other health coverage">
            <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.True" name="doYouHaveOtherHealthCoverage" formControlName="doYouHaveOtherHealthCoverage" (change)="doYouHaveOtherHealthCoverageChange(true)">
                <span>Yes</span>
            </label>
            <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.False" name="doYouHaveOtherHealthCoverage" formControlName="doYouHaveOtherHealthCoverage" (change)="doYouHaveOtherHealthCoverageChange(false)">
                <span>No</span>
            </label>
        </app-field>
        <section *ngIf="form.get('doYouHaveOtherHealthCoverage').value === CRMBoolean.True">
            <app-field label="Name of provider">
                <input class="form-control standard" type="text" formControlName="otherHealthCoverageProviderName">
            </app-field>
            <app-field label="Extended Health Plan Number">
                <input class="form-control standard" type="text" formControlName="otherHealthCoverageExtendedPlanNumber">
            </app-field>
        </section>

        <h2 class="blue-header">Treatment</h2>

        <div *ngIf="formType === ApplicationType.Victim_Application">
            <h3>Hospital Information</h3>
            <app-field label="Did you go to a hospital to be treated for injuries resulting from the incident?" [valid]="isFieldValid('wereYouTreatedAtHospital')" [required]="true" errorMessage="Please select whether you went to the hospital">
                <label class="inline-label">
                    <input type="radio" [value]="true" name="wereYouTreatedAtHospital" formControlName="wereYouTreatedAtHospital">
                    <span>Yes</span>
                </label>
                <label class="inline-label">
                    <input type="radio" [value]="false" name="wereYouTreatedAtHospital" formControlName="wereYouTreatedAtHospital">
                    <span>No</span>
                </label>
            </app-field>
            <section *ngIf="form.get('wereYouTreatedAtHospital').value === true">
                <app-field>
                    <label class="inline-label">
                        <input type="checkbox" style="margin-right: 10px;" formControlName="treatedOutsideBc" [value]="true">
                        <span>Click this checkbox if the hospital is outside of BC.</span>
                    </label>
                </app-field>

                <section *ngIf="form.get('treatedOutsideBc').value != true">
                    <app-field label="Name of hospital" [required]="true" [valid]="isFieldValid('treatedAtHospitalName')" errorMessage="Please select a hospital">
                        <select class="form-control standard" formControlName="treatedAtHospitalName">
                            <option value="">Select...</option>
                            <option *ngFor="let item of hospitalList" [value]="item">{{ item }}</option>
                        </select>
                    </app-field>
                </section>

                <section *ngIf="form.get('treatedOutsideBc').value === true">
                    <app-field label="Please enter the name, city and Province/State of the hospital below" [required]="form.get('treatedOutsideBc').value === true" [valid]="isMyControlValid(form.get('treatedOutsideBcHospitalName'))" errorMessage="Please enter hospital information">
                        <input class="form-control standard" type="text" formControlName="treatedOutsideBcHospitalName">
                    </app-field>
                </section>

                <app-field label="Date of Initial treatment">
                    <div class="hospital-date-container">
                        <app-date-field [control]="form.get('treatedAtHospitalDate')" [max]="today"></app-date-field>
                    </div>
                    <!-- <input type="text" [max]="today" class="form-control standard" formControlName="treatedAtHospitalDate" placeholder="yyyy-mm-dd" [matDatepicker]="treatedAtHospitalDatePicker" (focus)="treatedAtHospitalDatePicker.open()" (click)="treatedAtHospitalDatePicker.open()">
                    <mat-datepicker #treatedAtHospitalDatePicker></mat-datepicker> -->
                </app-field>
            </section>
        </div>
        <h3>Doctor Information</h3>
        <app-field label="Do you have a medical doctor / clinic who has been treating you for injuries resulting from the incident?" [valid]="isFieldValid('beingTreatedByFamilyDoctor')" [required]="true" errorMessage="Please select whether you have a medical doctor/clinic">
            <label class="inline-label">
                <input type="radio" (click)="addDoctor()" [value]="true" name="beingTreatedByFamilyDoctor" formControlName="beingTreatedByFamilyDoctor">
                <span>Yes</span>
            </label>
            <label class="inline-label">
                <input type="radio" (click)="clearDoctor()" [value]="false" name="beingTreatedByFamilyDoctor" formControlName="beingTreatedByFamilyDoctor">
                <span>No</span>
            </label>
        </app-field>
        <section *ngIf="form.get('beingTreatedByFamilyDoctor').value === true">
            <div class="row">
                <div class="col-md-6">
                    <app-field label="Name of Clinic" [required]="true" [valid]="isFieldValid('familyDoctorClinic')" errorMessage="Please enter the name of the clinic">
                        <input class="form-control" type="text" formControlName="familyDoctorClinic">
                    </app-field>
                </div>
                <div class="col-md-6">                    
                    <app-form-field 
                        label="Email Address" 
                        [control]="form.get('familyDoctorEmail')" 
                        inputType="email">
                    </app-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-field label="Doctor First Name" [required]="false" [valid]="isFieldValid('familyDoctorFirstName')" [errorMessage]="'Please enter the Doctor name'">
                        <input class="form-control" type="text" formControlName="familyDoctorFirstName">
                    </app-field>
                </div>
                <div class="col-md-6">
                    <app-field label="Doctor Last Name" [required]="false" [valid]="isFieldValid('familyDoctorLastName')" [errorMessage]="'Please enter the Doctor name'">
                        <input class="form-control" type="text" formControlName="familyDoctorLastName">
                    </app-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-field label="Phone Number (incl. area code)" [valid]="isMyControlValid(form.get('familyDoctorPhoneNumber'))" errorMessage="Please enter a valid phone number">
                        <input class="form-control" mask='(000) 000 0000' type="text" formControlName="familyDoctorPhoneNumber" *ngIf="form.get('familyDoctorAddress.country').value === 'Canada' || form.get('familyDoctorAddress.country').value === 'United States of America'; else phone_no_mask">
                        <ng-template #phone_no_mask>
                            <input class="form-control" type="text" formControlName="familyDoctorPhoneNumber" digitOnly>
                        </ng-template>
                    </app-field>
                </div>
                <div class="col-md-6">
                    <app-field [label]="'Fax' + (formType === ApplicationType.Victim_Application ? ' (providing will assist with obtaining medical information)' : '')" [valid]="isMyControlValid(form.get('familyDoctorFax'))" errorMessage="Please enter a valid fax number">
                        <input mask='(000) 000 0000' class="form-control" type="text" formControlName="familyDoctorFax">
                    </app-field>
                </div>
            </div>
            <app-address [group]="form.get('familyDoctorAddress')" [showChildrenAsRequired]="false"></app-address>
        </section>

        <h3>Other Treatment Information</h3>
        <app-field [label]="getOtherTreatmentLabel()" [valid]="isFieldValid('hadOtherTreatments')" [required]="true" errorMessage="Please select whether you have seen any other doctors, specialists, or counsellors">
            <label class="inline-label">
                <input type="radio" (click)="addProvider()" [value]="true" name="hadOtherTreatments" formControlName="hadOtherTreatments">
                <span>Yes</span>
            </label>
            <label class="inline-label">
                <input type="radio" (click)="clearProviders()" [value]="false" name="hadOtherTreatments" formControlName="hadOtherTreatments">
                <span>No</span>
            </label>
        </app-field>
        <section *ngIf="form.get('hadOtherTreatments').value === true" class="bottom-section-margin">
            <div class="other-treatments" formArrayName="otherTreatments" *ngFor="let item of form.get('otherTreatments')['controls']; let i = index;">
                <ng-container [formGroupName]="i" class="other-treatment">
                    <a href="javascript:void(0);" (click)="removeProvider(i)" class="float-right" *ngIf="showRemoveProvider">
                        <i class="fas fa-trash-alt"></i> Delete Provider
                    </a>
                    <h3>Provider {{ i + 1 }}</h3>
                    <div class="row">
                        <div class="col-md-6">
                            <app-field label="Name of Company/Organization" [required]="false" [valid]="isMyControlValid(item.get('providerCompany'))" errorMessage="Please enter company name">
                                <input type="text" class="form-control" formControlName="providerCompany">
                            </app-field>
                        </div>
                        <div class="col-md-6">
                            <app-form-field 
                                label="Email Address" 
                                [control]="item.get('providerEmail')" 
                                inputType="email">
                            </app-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <app-field label="Provider First Name" [valid]="isMyControlValid(item.get('providerFirstName'))" errorMessage="Please enter provider name">
                                <input type="text" class="form-control" formControlName="providerFirstName">
                            </app-field>
                        </div>
                        <div class="col-md-6">
                            <app-field label="Provider Last Name" [valid]="isMyControlValid(item.get('providerLastName'))" errorMessage="Please enter provider name">
                                <input type="text" class="form-control" formControlName="providerLastName">
                            </app-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <app-field label="Phone Number (incl. area code)" [valid]="isMyControlValid(item.get('providerPhoneNumber'))" errorMessage="Please enter a valid phone number">
                                <input class="form-control" mask='(000) 000 0000' type="text" formControlName="providerPhoneNumber" *ngIf="item.get('providerAddress.country').value === 'Canada' || item.get('providerAddress.country').value === 'United States of America'; else phone_no_mask">
                                <ng-template #phone_no_mask>
                                    <input class="form-control" type="text" formControlName="providerPhoneNumber" digitOnly>
                                </ng-template>
                            </app-field>
                        </div>
                        <div class="col-md-6">
                            <app-field label="Fax" [valid]="isMyControlValid(item.get('providerFax'))" errorMessage="Please enter a valid phone number">
                                <input class="form-control" mask='(000) 000 0000' type="text" formControlName="providerFax" *ngIf="item.get('providerAddress.country').value === 'Canada' || item.get('providerAddress.country').value === 'United States of America'; else fax_no_mask">
                                <ng-template #fax_no_mask>
                                    <input class="form-control" type="text" formControlName="providerFax" digitOnly>
                                </ng-template>
                            </app-field>
                        </div>
                    </div>

                    <div class="row" *ngIf="formType === ApplicationType.Victim_Application">
                        <div class="col-md-12">
                            <app-field label="Type of provider" [required]="true" [valid]="isMyControlValid(item.get('providerType'))" errorMessage="Please select the type of provider">
                                <label class="inline-label">
                                    <input type="radio" [value]="'Specialist'" formControlName="providerType">
                                    <span>Specialist</span>
                                </label>

                                <label class="inline-label">
                                    <input type="radio" [value]="'Counsellor'" formControlName="providerType">
                                    <span>Counsellor</span>
                                </label>

                                <label class="inline-label">
                                    <input type="radio" [value]="'Dentist'" formControlName="providerType">
                                    <span>Dentist</span>
                                </label>

                                <label class="inline-label">
                                    <input type="radio" [value]="'Other'" formControlName="providerType">
                                    <span>Other</span>
                                </label>

                                <div *ngIf="item.get('providerType').value === 'Other'">
                                    <label class="inline-label">
                                        <input type="text" maxlength="50" class="form-control" formControlName="providerTypeText">
                                    </label>
                                </div>
                            </app-field>
                        </div>
                    </div>
                    <app-address (change)="setProviderPhoneValidators(item)" [group]="item.get('providerAddress')" [showChildrenAsRequired]="false"></app-address>
                </ng-container>
            </div>
            <a href="javascript:void(0);" class="btn btn-secondary" (click)="addProvider()" *ngIf="showAddProvider">Add a Provider</a>
        </section>
    </section>

</div>